<template>
  <div class="Sidebar">
    <el-aside style="background-color: rgb(238, 241, 246)">
      <el-menu
        :default-openeds="['1','3']"
        @open="handleOpen"
        @close="handleClose"
        :collapse="isCollapse"
      >
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-tickets"></i>前台页面
          </template>
          <a href="http://www.i-jtjy.org/index/cooperation_units/cid/12.html">
            <el-menu-item index="1-1">
              <span slot="title">合作查询</span>
            </el-menu-item>
          </a>
          <router-link to="/zscx">
            <el-menu-item index="1-2">
              <span slot="title">证书查询</span>
            </el-menu-item>
          </router-link>
          <a href="http://www.i-jtjy.org/index/expert/cid/14.html">
            <el-menu-item index="1-3">
              <span slot="title">专家查询</span>
            </el-menu-item>
          </a>
        </el-submenu>

        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-setting"></i>后台设置
          </template>
          <router-link to="/reguser">
            <el-menu-item index="2-1">注册管理员</el-menu-item>
          </router-link>
          <router-link to="/users">
            <el-menu-item index="2-2">管理员列表</el-menu-item>
          </router-link>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-edit"></i>报名管理
          </template>
          <router-link to="/datalist">
            <el-menu-item index="3-1">报名列表</el-menu-item>
          </router-link>
          <router-link to="/adddata">
            <el-menu-item index="3-2">新增数据</el-menu-item>
          </router-link>
        </el-submenu>
        <el-menu-item index="4" @click.native="logout">
          <i class="el-icon-sold-out"></i>
          <span slot="title">退出登录</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data() {
    return {
      isCollapse: false
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    logout(event) {
      this.$store.commit('REMOVE_COUNT')
      this.$message('退出登录!')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.Sidebar > .el-aside {
  height: 100%;
}
.el-menu {
  height: 100%;
}
</style>
